import { Injectable } from '@angular/core';
import { Action, State, type StateContext } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AlertControlActions } from '@medsurf/flat-actions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AlertControlStateModel {
  ids: Set<string>;
}

@State<AlertControlStateModel>({
  name: 'alertControl',
  defaults: {
    ids: new Set<string>()
  }
})
@Injectable()
export class AlertControlState {
  constructor(protected translate: TranslateService,
              protected messageService: MessageService) {
  }

  //<editor-fold desc="Actions">

  @Action(AlertControlActions.AddAlert)
  addAlert(state: StateContext<AlertControlStateModel>,
           {message}: AlertControlActions.AddAlert): void {
    // Deduplicate Error Alerts
    if (message.id) {
      const ids = new Set(state.getState().ids);
      if (ids.has(message.id)) {
        return;
      }
      ids.add(message.id);
      state.patchState({
        ids
      })
    }

    // Translate
    if (message.summary) {
      message.summary = this.translate.instant(message.summary, message.data);
    }
    if (message.detail) {
      message.detail = this.translate.instant(message.detail, message.data);
    }

    // Add Message
    this.messageService.add(message);
  }

  @Action(AlertControlActions.ClearAlerts)
  clearAlerts(): void {
    this.messageService.clear()
  }

  //</editor-fold>
}
